import styles from '../CaseBuilderEnhanced.module.css';

export default function ConfirmDialog({
    open,
    title,
    message,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    variant = 'primary',
    confirmDisabled = false,
    hideCancel = false,
    onConfirm,
    onCancel,
}) {
    if (!open) return null;

    const confirmClass = variant === 'danger' ? styles.buttonDanger : styles.buttonPrimary;

    return (
        <div className={styles.dialogOverlay} role="dialog" aria-modal="true">
            <div className={styles.dialog}>
                <h3 className={styles.dialogTitle}>{title}</h3>
                <p className={styles.dialogBody}>{message}</p>
                <div className={styles.dialogActions}>
                    {!hideCancel && (
                        <button
                            type="button"
                            className={styles.buttonSecondary}
                            onClick={onCancel}
                            disabled={confirmDisabled}
                        >
                            {cancelLabel}
                        </button>
                    )}
                    <button
                        type="button"
                        className={confirmClass}
                        onClick={onConfirm}
                        disabled={confirmDisabled}
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    );
}
